import { render, staticRenderFns } from "./importdelivery.vue?vue&type=template&id=c5ca94ca&"
import script from "./importdelivery.vue?vue&type=script&lang=js&"
export * from "./importdelivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports